import React from "react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50 p-4">
      <div className="bg-white w-full max-w-md md:max-w-lg lg:max-w-xl rounded-lg shadow-lg p-6 flex flex-col justify-between text-left">
        <button
          onClick={onClose}
          className="text-black text-lg font-bold self-end"
        >
          ✖
        </button>

        <h2 className="text-lg md:text-xl font-semibold">
          Are you sure you want to proceed?
        </h2>
        <h1 className="text-lg mb-1 mt-3">Before proceeding, ensure:</h1>
        <ul className="text-[#000000] text-sm md:text-base list-disc pl-7 ml-4">
          <li>All data entries are accurate and up-to-date.</li>
          <li>Payments correspond to the correct Member IDs and members.</li>
          <li>Uploaded data follows the required format.</li>
        </ul>

        <div className="flex justify-start gap-4 mt-4 flex-wrap">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#FF3232] h-[48px] text-white font-semibold rounded-lg w-full sm:w-auto"
          >
            No, cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-[#8ED6A8] text-[#005C53] h-[48px] font-semibold rounded-lg w-full sm:w-auto"
          >
            Yes, continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
